/*
 * @Author: cn1994
 * @Date: 2024-02-21 15:46:34
 * @LastEditors: cn1994
 * @LastEditTime: 2024-12-13 15:40:01
 * @Description: file content
 */
// 资源相关的路由--美术音乐舞蹈类
import { useInstStore } from '@/stores/inst'


function textbookV7() {
  const instStore = useInstStore()
  let subject = instStore.subject;
  if (['dentistry', 'art'].some(item => item == subject) || instStore.isBusinessSchool) {
    return '素材'
  } else if (['robot', 'program'].some(item => item == subject)) {
    return '教程'
  } else if (subject == 'music') {
    return '乐谱'
  } else if (subject == 'dance') {
    return '音乐'
  } else if (subject == 'chess') {
    return '棋谱'
  } else {
    return ''
  }
}

function textbookV9() {
  const instStore = useInstStore()
  let subject = instStore.subject;
  if (["music", "dance", "art", "chess"].some(item => item == subject)) {
    return `学校${textbookV7()}教程`
  } else if (["program", "robot"].some(item => item == subject)) {
    return '学校教程区'
  }
}

const routes = [
  //班级教材
  {
    path: '/classMaterialsArt',
    name: 'textbookClass',
    meta: {
      title: '班级教材',
      volcengine: true,
    },
    component: () => import('../pages/textbook/classArt/class.vue'),
  },
  // 班级教材列表
  {
    path: '/classMaterialsArt/detail',
    name: 'textbookClass/detail',
    meta: {
      title: "班级课件",
      volcengine: true,
    },
    component: () => import('../pages/textbook/classArt/classDetail.vue'),
  },

  // 班级文件夹下的教材列表
  {
    path: '/classMaterialsArt/folder/detail',
    name: 'classMaterialsArt/folder/detail',
    meta: {
      title: "班级课件",
      volcengine: true,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.folderName) {
        to.meta.title = `班级课件-${to.query.folderName}`
      }
      next()
    },
    component: () => import('../pages/textbook/classArt/classFolderDetail.vue'),
  },
  //学校教材区
  {
    path: '/schoolMaterialsAreaArt',
    name: 'schoolMaterialsAreaArt',
    meta: {
      title: "学校教材区",
      volcengine: true,
    },
    component: () => import('../pages/textbook/schoolArt/school.vue'),
  },
  // 班级文件夹下的教材列表
  {
    path: '/schoolMaterialsAreaArt/detail',
    name: 'schoolMaterialsAreaArt/detail',
    meta: {
      title: "学校教材区",
      volcengine: true,
    },
    beforeEnter: (to, from, next) => {
      // 必须异步
      setTimeout(()=>{
        if (to.query.title) {
          to.meta.title = `${textbookV9()}-${to.query.title}`
        }
        next()
      })
    },
    component: () => import('../pages/textbook/schoolArt/detail.vue'),
  },
  // 自制内容区
  {
    path: '/mineMaterialsArt',
    name: 'mineMaterialsArt',
    meta: {
      title: "自制内容区",
      volcengine: true,
    },
    component: () => import('../pages/textbook/mineArt/mine.vue'),
  },
   // 创建课程
   {
    path: '/mineMaterialsArt/createCourse',
    name: 'mineMaterialsArt/createCourse',
    meta: {
      title: "创建课程"
    },
    component: () => import('../pages/textbook/createCourse/index.vue'),
  },
  // 自制内容区
  {
    path: '/mineMaterialsArt/detail',
    name: 'mineMaterialsArt/detail',
    meta: {
      title: "自制内容区",
      volcengine: true,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.folderName) {
        to.meta.title = `自制内容区-${to.query.folderName}`
      }
      next()
    },
    component: () => import('../pages/textbook/mineArt/mineDetail.vue'),
  },
  // 创建课程
  {
    path: '/mineMaterials/createCourse',
    name: 'mineMaterials/createCourse',
    meta: {
      title: "创建课程",
      volcengine: true,
    },
    component: () => import('../pages/textbook/createCourse/index.vue'),
  },
  // 创建曲谱
  {
    path: '/mineMaterials/createMusic',
    name: 'mineMaterials/createMusic',
    meta: {
      title: "新建乐谱",
      volcengine: true,
    },
    component: () => import('../pages/createMusic/index.vue'),
  },
  // 创建课程
  {
    path: '/readMaterials/createCourse',
    name: 'readMaterials/createCourse',
    meta: {
      title: "创建课程",
      volcengine: true,
    },
    component: () => import('../pages/textbook/createCourse/index.vue'),
  },
  // 制作视频配音课件
  {
    path: '/readMaterials/createVideoDubbing',
    name: 'readMaterials/createVideoDubbing',
    meta: { title: "制作视频配音" },
    component: () => import('../pages/createVideoDubbing/editBook.vue'),
  },
  // 创建课程
  {
    path: '/schoolMaterialsArea/createCourse',
    name: 'schoolMaterialsArea/createCourse',
    meta: {
      title: "创建课程",
      volcengine: true,
    },
    component: () => import('../pages/textbook/createCourse/index.vue'),
  },
  // 制作视频配音课件
  {
    path: '/schoolMaterialsArea/createVideoDubbing',
    name: 'schoolMaterialsArea/createVideoDubbing',
    meta: { title: "制作视频配音" },
    component: () => import('../pages/createVideoDubbing/editBook.vue'),
  },
  // 视频配音
  {
    path: '/dubbingVideo',
    name: 'dubbingVideo',
    meta: { title: "视频配音" },
    component: () => import('../pages/textbook/dubbingVideo/index.vue'),
  },

  // 企培教材路由
  //学校教材区
  {
    path: '/schoolMaterialsAreaQp',
    name: 'schoolMaterialsAreaQp',
    component: () => import('../pages/textbookQp/school/school.vue'),
  },
  // 班级文件夹下的教材列表
  {
    path: '/schoolMaterialsAreaQp/detail',
    name: 'schoolMaterialsAreaQp/detail',
    meta: { title: "学校教材区" },
    component: () => import('../pages/textbookQp/school/detail.vue'),
  },
  //阅读区教材
  {
    path: '/readMaterialsQp',
    name: 'readMaterialsQp',
    component: () => import('../pages/textbookQp/read/read.vue'),
  },
  //班级教材
  {
    path: '/classMaterialsQp',
    name: 'classMaterialsQp',
    component: () => import('../pages/textbookQp/class/class.vue'),
  },
  // 班级教材列表
  {
    path: '/classMaterialsQp/detail',
    name: 'classMaterialsQp/detail',
    meta: { title: "班级教材" },
    component: () => import('../pages/textbookQp/class/classDetail.vue'),
  },
  // 班级文件夹下的教材列表
  {
    path: '/classMaterialsQp/folder/detail',
    name: 'classMaterialsQp/folder/detail',
    meta: { title: "班级教材" },
    component: () => import('../pages/textbookQp/class/classFolderDetail.vue'),
  },
  //自制教材
  {
    path: '/mineMaterialsQp',
    name: 'textbookMineQp',
    component: () => import('../pages/textbookQp/mine/mine.vue'),
  },
  //自制文件夹教材详情
  {
    path: '/mineMaterialsQp/mineDetail',
    name: 'textbookMineQp/mineDetail',
    meta: { title: "自制教材" },
    component: () => import('../pages/textbookQp/module/mineDetail.vue'),
  },
  // 创建课程
  {
    path: '/mineMaterialsQp/createCourse',
    name: 'mineMaterialsQp/createCourse',
    meta: { title: "创建课程" },
    component: () => import('../pages/textbookQpV2/createCourse/index.vue'),
  },
  // 创建课程
  {
    path: '/readMaterialsQp/createCourse',
    name: 'readMaterialsQp/createCourse',
    meta: { title: "创建课程" },
    component: () => import('../pages/textbookQpV2/createCourse/index.vue'),
  },
  // 创建课程
  {
    path: '/schoolMaterialsAreaQp/createCourse',
    name: 'schoolMaterialsAreaQp/createCourse',
    meta: { title: "创建课程" },
    component: () => import('../pages/textbookQpV2/createCourse/index.vue'),
  },
  // 素材库
  {
    path: '/resourceLibrary',
    name: 'resourceLibrary',
    meta: { title: "素材库" },
    component: () => import('../pages/textbook/resourceLibrary/index.vue'),
  },
]

export default routes
